import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'
import { push } from 'react-router-redux'

import * as OrgActions from 'modules/org/actions'
import * as actions from 'modules/profile/actions'
import * as selectors from 'modules/profile/selectors'
import { page, track } from 'utils/trackingUtils'

import ProfileDetailsStep from './component'

const mapStateToProps = state => ({
  jobTitle: selectors.getJobTitle(state),
  companyName: selectors.getCompanyName(state),
  companyUrl: selectors.getCompanyUrl(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setJobTitle: actions.setJobTitle,
    setCompanyName: actions.setCompanyName,
    setCompanyUrl: actions.setCompanyUrl,
    updateEmbed: OrgActions.updateEmbed,
    push,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Profile Company Setup', {
        context: 'sales-onboarding',
      })
    }
  }),
  withHandlers({
    onJobTitleChange: props => event => {
      props.actions.setJobTitle(event.target.value)
    },
    onCompanyNameChange: props => event => {
      props.actions.setCompanyName(event.target.value)
    },
    onCompanyUrlChange: props => event => {
      props.actions.setCompanyUrl(event.target.value)
    },
    onContinueClick: props => () => {
      track('Onboarding Profile Company Setup Completed', {
        context: 'sales-onboarding',
        companyName: props.companyName,
        companyUrl: props.companyUrl,
        jobTitle: props.jobTitle
      })
      props.actions.updateEmbed([{
        operation: 'set',
        value: props.companyName,
        property: 'organizationName',
      }, {
        operation: 'set',
        value: props.companyUrl,
        property: 'organizationUrl',
      }])
      props.actions.push('/setup/password')
    },
  }),
)(ProfileDetailsStep)



// WEBPACK FOOTER //
// ./src/layouts/ProfileDetailsStep/index.js